import { Button } from '@wheely/ui-kit';
import React from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getCountryCode } from '@/modules/common/store/selectors';
import { TUpdateContactInfoForm } from '@/modules/partner/model/Partner';
import { usePhoneCodes } from '@/shared/hooks/usePhoneCodes';
import { CountryCode } from '@/shared/models/country-code';
import { BottomButtons } from '@/shared/view/BottomButtons';
import { StepLayout } from '@/shared/view/StepLayout';
import { PhoneField } from '@src-common/view/adapters/reactHookForm/PhoneField';

type IEditContactProps = {
  control: Control<TUpdateContactInfoForm>;
  isSubmitting?: boolean;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  onGoBack: () => void;
};

const EditContactView = ({ onSubmit, control, isSubmitting, onGoBack }: IEditContactProps) => {
  const intl = useIntl();
  const phoneCodes = usePhoneCodes();
  const countryCode = useSelector(getCountryCode);

  return (
    <StepLayout
      hideProgress={true}
      title={intl.formatMessage({
        defaultMessage: 'Contact information',
        id: 'N5g41j',
        description: 'Edit Contact information screen: title',
      })}
      onClickBack={onGoBack}
    >
      <form onSubmit={onSubmit}>
        <PhoneField
          name="phoneNumber"
          namePhoneCode="phoneCode"
          title={intl.formatMessage({
            defaultMessage: 'Phone',
            id: 'sWCsmt',
            description: 'Phone field title',
          })}
          control={control}
          isRequired={true}
          items={phoneCodes}
          description={
            countryCode === CountryCode.France &&
            intl.formatMessage({
              defaultMessage: 'Enter phone number without 0',
              id: 'V8we6R',
              description: 'Phone field note',
            })
          }
        />

        <BottomButtons>
          <Button type="submit" disabled={isSubmitting}>
            <FormattedMessage defaultMessage="Save" id="RT8KNi" description="Save button text" />
          </Button>
        </BottomButtons>
      </form>
    </StepLayout>
  );
};

export { EditContactView };
